<mat-sidenav-container class="sidenav-container">

    <mat-sidenav #sidenav class="sidenav" [mode]="mobileQuery.matches ? 'over' : 'side'" opened
        [fixedInViewport]="mobileQuery.matches" fixedTopGap="42" fixedBottomGap="42">

        <mat-nav-list>

            <mat-accordion >

                <mat-expansion-panel *ngFor="let e of menuList" >

                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{ e.nombre }}
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <mat-list-item [routerLink]="modulo + m.url" routerLinkActive="is-active" *ngFor="let m of e.menu">
                        <mat-icon>{{m.icono}}</mat-icon>
                        <span style="font-size: 15px;">
                            {{m.nombre}}
                        </span>
                    </mat-list-item>

                </mat-expansion-panel>
            </mat-accordion>

        </mat-nav-list>

    </mat-sidenav>

    <mat-sidenav-content class="backoffice-content">
        <app-loader></app-loader>
        <router-outlet></router-outlet>
    </mat-sidenav-content>

</mat-sidenav-container>
